<template>
  <modal :modal-key="'zero-balance-modal'"
         :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_games_left_zero_balance_zero_game_balance }}</h1>
      <div class="bounce_box bounce_animation">
        <img class="icon" src="static/images/locked_icon.svg" alt="">
      </div>
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_games_left_zero_balance_unlock_more_games_msg }}
    </template>
    <template slot="footer">
      <a v-if="!hideStore">
        <div class="btn2 btn2--std btn2--small btn2--fixed" style="cursor:pointer" @click.prevent="toBundlesPage">{{
          getTranslations.home_modals_games_left_zero_balance_unlock_games }}
        </div>
      </a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'games-left-zero-balance-modal',
  components: {
    Modal,
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/GamesLeftZeroBalance.vue